import * as React from 'react';
import { PermissionsContext } from '../Contexts/PermissionsContext';
// import Typography from '@mui/material/Typography';

export default function SuperAdminPowerBI() {

    const [Access, SetAccess] = React.useState(false);
    const { checkHasPermission } = React.useContext(PermissionsContext);

    React.useEffect(() => {
        if (checkHasPermission("")) {
            SetAccess(true);
        }
    }, []);



    return (
        <React.Fragment>
            {
                Access &&
                <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', overflow: 'hidden' }}>
                    <iframe style={{ flexGrow: 1, border: 'none', margin: 0, padding: 0, height: 'calc(100vh - 100px)' }} src="https://app.powerbi.com/reportEmbed?reportId=3c65d8f5-578a-4062-9a8c-e8e9e7d0c6bf&autoAuth=true&ctid=7c73f318-8050-40b6-b6d2-60f617aa1490&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVrLXNvdXRoLWItcHJpbWFyeS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D" ></iframe>
                </div>
            }
        </React.Fragment>
    );
}